<template>
	<div style="height:100%; width:100% ; overflow: auto;">

		<div class="rowitem" v-for="(item,idx) in DataList" :key="item.id" @click="">
			<div class="rowtitle">
				{{item.title}}
			</div>
			<div class="rowdate">
				{{item.cdate}}
			</div>
		</div>

	</div>
</template>

<script>

export default {

	data() {
		return {
			DataList: []

		};
	},
	mounted() {

		this.getData()
	},
	methods: {
		getData() {
			this.$http.post("/api/home_todo").then(res => {
				this.DataList = res.data

			})
		},


	}
}


</script>

<style scoped="scoped">

.rowitem{ display: flex; font-size: 14px; line-height: 30px; cursor: pointer; border-bottom: 1px solid #eee;}
.rowtitle{ width: 80%; overflow: hidden;white-space: nowrap; text-overflow: ellipsis; }
.rowdate{ width: 20%; text-align: center; overflow: hidden;white-space: nowrap; text-overflow: ellipsis;}
</style>
